module.exports = __webpack_public_path__ + "static/media/Berkeley-Rally-9_11.e5519863.mp4";